// services/childcare/staff.js
import { api } from "./utils";

const BASE_URL = "/childcare/staff";

export const getStaffList = async (params = {}) => {
  return api.get(BASE_URL, { params });
};

export const getStaffById = async (id) => {
  return api.get(`${BASE_URL}/${id}`);
};

export const createStaff = async (data) => {
  return api.post(BASE_URL, data);
};

export const updateStaff = async (id, data) => {
  return api.put(`${BASE_URL}/${id}`, data);
};

export const deleteStaff = async (id) => {
  return api.delete(`${BASE_URL}/${id}`);
};

export const resendInvitation = async (id) => {
  return api.post(`${BASE_URL}/${id}/resend`);
};

export const getCaregivers = async () => {
  return api.get(`${BASE_URL}/caregivers`);
};

export const getTutors = async () => {
  return api.get(`${BASE_URL}?role=tutor`);
};

// New functions for program staff management
export const getAvailableProgramStaff = async (programId = null) => {
  const url = programId
    ? `${BASE_URL}/available/${programId}`
    : `${BASE_URL}/available`;
  return api.get(url);
};

export const getProgramStaff = async (programId) => {
  return api.get(`${BASE_URL}/program/${programId}`);
};

export const assignStaffToProgram = async (programId, staffData) => {
  return api.post(`${BASE_URL}/program/${programId}/assign`, staffData);
};

export const removeStaffFromProgram = async (programId, staffId, role) => {
  return api.delete(`${BASE_URL}/program/${programId}/staff/${staffId}`, {
    data: { role },
  });
};

// Legacy functions (deprecated but kept for backward compatibility)
export const assignStaffToClass = async (data) => {
  console.warn(
    "assignStaffToClass is deprecated. Use assignStaffToProgram instead.",
  );
  return api.post(`${BASE_URL}/assign-program`, data);
};

export const removeStaffFromClass = async (staffId, classId) => {
  console.warn(
    "removeStaffFromClass is deprecated. Use removeStaffFromProgram instead.",
  );
  return api.delete(`${BASE_URL}/program/${classId}/staff/${staffId}`);
};
